// Language index based on API response's bilingual field
const LANGUAGE_INDEX = {
  id: 0,
  en: 1,
}

function getLanguageValue(data, languageName){
  return data[LANGUAGE_INDEX[languageName]]
}

export { getLanguageValue }
